import { api } from "data";
import { useCustomMutation } from "data/modules/api/hooks/useCustomMutation";

export const useDeleteBookingQuestions = () => {
  return useCustomMutation({
    url: api.questions.delete_question,
    onMutate: () => null,
    onSettled: () => null,
    onSuccess: () => null,
  });
};
